<template>
  <div>
    <!-- 搜索区 -->
    <search-component @handleQueryData="handelSearch" />
    <empty-component v-if="isEmpty" />
    <add-btn @add="handleAddExecutive" />
    <van-list v-model="loading" :finished="noOrderFinished"  finished-text="没有更多了" @load="handleList" v-if="list.length > 0">
      <total-component :totalValue="total" />
      <van-cell-group>
        <van-cell v-for="(item,index) in list" :title="item.execCustomerName  + '(' + item.bussUserName + ')'" :key="index" style="padding-top: 20px;padding-bottom: 20px">
          <template #right-icon>
            <van-button v-if="channelType == 2 || (channelType == 3 &&
               ($store.state.user.user.userId === 1 || $store.state.user.user.userId === 539 || $store.state.user.user.userId === 540 || $store.state.user.user.userId === 541))"
               type="info" size="mini" plain @click="showPayer(item)">付款单位</van-button>
            <van-button type="info" size="mini" plain @click="editExecutive(item)">修改</van-button>
            <!-- <van-button size="mini" color="#ee0a24" plain @click="deleteExecutive(item)">删除</van-button> -->
          </template>
        </van-cell>
      </van-cell-group>
    </van-list>

    <!-- 付款单位 -->
    <van-dialog v-model="showPayerList" class="contract" width="97%" style="height: 80%;overflow: scroll;" title="付款单位列表" :showConfirmButton = 'false' :close-on-click-overlay="true">
      <div style="display: flex;justify-content: flex-end;padding-right: 30px;">
        <van-button size="small" type="info" @click="addPayer" style="border-radius: 5px;">+新增付款单位</van-button>
      </div>
      <van-list class="van-list" v-model="payerLoading" style="height: 80%;margin-top: -40px" :finished="true" v-if="payerList.length > 0">
        <van-cell-group>
          <van-cell v-for="(item,index) in payerList" :title="item.contPayCompanyName + '(' + item.createBy + ')'" :key="index" style="padding-top: 20px;padding-bottom: 20px">
            <template #right-icon v-if="item.userId == $store.state.user.user.userId">
              <van-button type="warning" size="mini" plain @click="updatePayer(item)">修改</van-button>
              <van-button size="mini" color="#ee0a24" plain @click="deletePayer(item)">删除</van-button>
            </template>
          </van-cell>
        </van-cell-group>
      </van-list>
      <empty-component v-if="payerList.length == 0" />
    </van-dialog>
    <van-dialog v-model="showPayerForm" title="付款单位" width="95%" style="height:30%" class="editClue" :beforeClose="payerBeforeClose" show-cancel-button>
      <van-form ref="payerForm" validate-trigger="onSubmit" class="dialog-form-wrap" style="height:98%;">
        <van-field v-model="payerForm.contPayCompanyName" label="付款单位" placeholder="请输入付款单位" :rules="[{ required: true }]" required />
      </van-form>
    </van-dialog>
    <dialog-executive :show='show' :isAdd="isAdd" :modifyObj="form" :contractId="contractId" @beforeClose='addExecutivBeforeClose'></dialog-executive>
  </div>
</template>

<script>
import payment from '@/api/cont/payment'
// import { getDicts } from '@/api/system/dict/data'
import SearchComponent from '@/components/common/Search'
import TotalComponent from '@/components/common/Total'
import EmptyComponent from '@/components/common/Empty'
import AddBtn from '@/components/common/AddBtn'
import DialogExecutive from '../components/DialogExecutive.vue'
import { Toast, Dialog } from 'vant'
export default {
  name: 'custClue',
  components: {
    SearchComponent,
    EmptyComponent,
    TotalComponent,
    AddBtn,
    [Toast.name]: Toast,
    [Dialog.Component.name]: Dialog.Component,
    DialogExecutive
  },
  data() {
    return {
      isEmpty: false,
      show: false,
      isAdd: true,
      activeNames: ['0', '1'],
      activeNamesP: [0],
      picker: {
        visible: false,
        visibleIndustry: false,
        title: '',
        columns: [],
        formKey: ''
      },
      datePicker: {
        showDate: false,
        minDate: new Date(2010, 0, 1),
        maxDate: new Date(2042, 11, 31),
        type: 'single',
        formKey: ''
      },
      loading: false,
      noOrderFinished: false,
      list: [],
      total: 0,
      searchValue: '',
      // options: {
      //   // 客户类型字典
      //   custTypeOptions: this.$store.state.dictOptions.crmCustType || [],
      //   // 客户来源字典
      //   custSourceOptions: this.$store.state.dictOptions.custSource || [],
      //   // 客户状态
      //   custStatusOptions: this.$store.state.dictOptions.custStatus || []
      // },
      contractId: '',
      channelType: null,
      form: {
        execCustomerName: null,
        pointList: [{}],
        contractId: null
      },
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        contractId: '',
        execCustomerName: null,
        orderByColumn: 'createTime',
        isAsc: 'desc'
      },

      // 付款单位
      execCustomerId: null,
      execCustomerName: null,
      showPayerList: false,
      payerLoading: false,
      payerList: [],

      showPayerForm: false,
      payerForm: {
        contractId: null,
        execCustomerId: null,
        contPayCompanyName: null,
        contPayCompanyId: null
      }
    }
  },
  created() {
    if (this.$route.query.contractId) {
      this.contractId = this.$route.query.contractId
      this.channelType = this.$route.query.channelType
      this.form.contractId = this.$route.query.contractId
      this.queryParams.contractId = this.$route.query.contractId
      this.queryParams.channelType = this.$route.query.channelType
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      document.title = '执行客户'
      await this.handleList()
    },
    QueryReset() {
      this.queryParams = {
        pageNum: 1,
        pageSize: 10,
        contractId: this.contractId
      }
    },
    // 搜索子组件传递过来的搜索关键字
    handelSearch(data) {
      this.isEmpty = false
      this.QueryReset()
      this.queryParams.execCustomerName = this.searchValue = data
      this.queryCustList()
    },
    // 过滤子组件传递过来的搜索对象
    handleFqueryFilter(data) {
      this.isEmpty = false
      const query = this.queryParams
      this.queryParams = { ...query, ...data }
      this.queryCustList()
    },
    queryCustList() {
      this.list = []
      this.queryParams.pageNum = 1
      this.handleList()
      // this.handleList();
    },
    async handleList() {
      this.loading = true
      // this.queryParams.custName = this.$route.query.custName || ''
      const res = await payment.listExecutive(this.queryParams)
      if (res.code === 200) {
        if (res.rows.length === 0) {
          this.isEmpty = true
        } else {
          this.isEmpty = false
        }
        this.list = this.list.concat(...res.rows)
        this.queryParams.pageNum += 1
        this.total = res.total
        this.loading = false
        this.noOrderFinished = this.list.length >= res.total
      }
    },
    onLoad() {
      this.handleList()
    },
    handleAddExecutive() {
      this.isAdd = true
      this.show = true
      // this.form = {
      //   pointList: [{ useMoney: '' }],
      //   contractId: this.contractId
      // }
    },
    editExecutive(item) {
      this.isAdd = false
      payment.getExecutive(item.execCustomerId).then(res => {
        if (res.code === 200) {
          this.form = res.data
          this.form.pointList.map(item => {
            if (item.startTime && item.endTime) { item.zxTime = `${item.startTime} 至 ${item.endTime}` }
          })
        }
      })
      this.show = true
    },
    deleteExecutive(item) {
      Dialog.confirm({
        message: '是否删除该执行客户'
      })
        .then(() => {
          payment.deleteExecutive(item.execCustomerId).then(res => {
            if (res.code === 200) {
              Toast.success('删除成功')
              setTimeout(() => {
                this.queryCustList()
              }, 500)
            }
          })
        })
        .catch(() => {
        // on cancel
        })
    },
    addExecutivBeforeClose() {
      this.show = false
      this.queryCustList()
    },
    // 付款单位
    async showPayer(row) {
      this.execCustomerId = row.execCustomerId
      this.execCustomerName = row.execCustomerName
      await this.getListPayer()
      this.showPayerList = true
    },
    async getListPayer() {
      await payment.listChannelPayer({ contractId: this.contractId, execCustomerId: this.execCustomerId }).then(response => {
        if (response.code === 200) {
          this.payerList = response.rows
          this.showPayerList = true
        }
      })
    },
    addPayer() {
      this.showPayerForm = true
    },
    updatePayer(row) {
      this.payerForm = row
      this.showPayerForm = true
    },
    async payerBeforeClose(type, done) {
      if (type === 'confirm') {
        try {
          await this.$refs.payerForm.validate()
          if (this.payerForm.contPayCompanyId) {
            await payment.updateChannelPayer(this.payerForm).then(() => {
              Toast.success('修改成功')
              setTimeout(() => {
                this.showPayerForm = false
                this.getListPayer()
              }, 500)
            })
          } else {
            this.payerForm.contractId = this.contractId
            this.payerForm.execCustomerId = this.execCustomerId
            // this.payerForm.execCustomerName = this.execCustomerName
            await payment.addChannelPayer(this.payerForm).then(() => {
              Toast.success('添加成功')
              setTimeout(() => {
                this.showPayerForm = false
                this.getListPayer()
              }, 500)
            })
          }
        } catch (err) {
          return done(false)
        }
        return done(false)
      } else {
        done()
        this.showPayerForm = false
      }
    },
    deletePayer(row) {
      const that = this
      Dialog.confirm({
        message: '是否删除该付款单位'
      })
        .then(() => {
          payment.deleteChannelPayer(row.contPayCompanyId).then(res => {
            if (res.code === 200) {
              Toast.success('删除成功')
              setTimeout(() => {
                that.getListPayer()
              }, 500)
            }
          })
        })
        .catch(() => {
        // on cancel
        })
    }
  }
}
</script>
<style lang="less" scoped>
@import url("@/style/index.less");
.listClue /deep/ .van-dialog__content {
  height: 80%;
}
.van-collaps-title{
  color: #1989fa;
}
/deep/.van-collapse-item__content{
  padding: 10px;
}
.editClue /deep/ .van-dialog__content {
  height: 46%;
}
</style>
